import axios from 'axios'
import store from '@/store'
import {errorNotify} from "./alertutil";
import {getToken} from '@/utils/auth'
import alertify from 'alertifyjs'

// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 10 * 60 * 1000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    config.headers = {
      'Content-Type':'application/json', //
      'channel': 'pc-web'
    }

    // Do something before request is sent
    const tk = getToken()
    console.log("interceptors token", tk)
    if (tk) {
      // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
      config.headers['tk'] = tk
    }
    // 特殊接口超时时间特殊处理
    // if (config.url.search('kunya-service-report-export') != -1) {
    //   config.timeout = 20000;
    // } else {
    //   config.timeout = 5000;
    // }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  // response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    const res = response.data
    if (res.code !== '0') {
      if (res.code === '098') {

        // alertify.alert('登录状态失效', '点击按钮重新登录', function(){
        //   store.dispatch('logOut').then(() => {
        //     location.reload()
        //   })
        // }).set('closable', false).set('label', '确定');

        alertify.alert(
          '登录状态失效', '无系统访问权限。',function(){
            if(process.env.NODE_ENV=='development'||window.location.host.indexOf("test")!=-1){
              window.location.href='http://hosp-test.zzitec.com/#/welcome'
            }else{
              window.location.href='http://hosp.zzitec.com/#/welcome'
            }
          }).set('closable', false).set('label', '确定');

      }  else if (res.code === '002') {

        // alertify.alert('权限失效', '您没有本资源的访问权限。', function(){
        //   store.dispatch('logOut').then(() => {
        //     location.reload()
        //   })
        // }).set('closable', false).set('label', '确定');

        alertify.alert(
          '权限失效', '无系统访问权限。',function(){
            if(process.env.NODE_ENV=='development'||window.location.host.indexOf("test")!=-1){
              window.location.href='http://hosp-test.zzitec.com/#/welcome'
            }else{
              window.location.href='http://hosp.zzitec.com/#/welcome'
            }
          }).set('closable', false).set('label', '确定');

      } else {
        errorNotify(res.msg)
      }

      return Promise.reject(res.msg)
    } else {
      console.log('response suceess', res)
      return res.data
    }
  },
  error => {
    if (error.response && error.response.status == 504) {

      errorNotify('无法连接服务器,请刷新或稍后再试')


    } else if (error.response && error.response.status == 403) {

      errorNotify('您所访问的资源不存在，请刷新页面和缓存或联系管理员')

    } else {
      errorNotify(error.message)
    }

    return Promise.reject(error)
  }
)

export default service
